import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SecurityService } from '../security.service';
import { FindingDetailDialogComponent } from '../../apps/app-data/app-close-issues/finding-detail-dialog/finding-detail-dialog.component';
import { jsonResponseApi } from '../../../shared/models/json-response.model';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../shared/utils/globals';
import { SecurityFindingComment } from '../../../shared/models/security-finding-comment.model';
@Component({
  selector: 'app-security-table-findings-comments',
  templateUrl: './table-findings-comments.component.html',
  styleUrls: ['./table-findings-comments.component.scss'],
})
export class TableFindingsCommentsComponent implements OnInit, AfterViewInit {
  @Input() collapsedSideBar: boolean = false;
  @Input() tblCols: string[];
  @Input() tblData: SecurityFindingComment[];
  @Output() SearchFindings: EventEmitter<SecurityFindingComment[]> =
    new EventEmitter<SecurityFindingComment[]>();
  @Output() getFindingsComments: EventEmitter<SecurityFindingComment[]> =
    new EventEmitter<SecurityFindingComment[]>();

  closeTargetIcon: string = '../../../assets/images/icons/icons-close-on.svg';
  linkIcon: string = '../../../assets/images/icons/link-icon.png';
  reloadIcon: string = '../../../assets/images/icons/reload.gif';
  dataSource: MatTableDataSource<SecurityFindingComment>;
  findingsNumber: number;
  loadedFindingsFiltered: SecurityFindingComment[];
  txtSearch: string;
  showAllFilters: boolean = false;
  pWidth: number;
  platform: string;
  dateFilter: string;
  week: number = 7;
  twoWeeks: number = 14;
  month: number = 31;
  filterPlatform: any = [
    {
      name: this.translate.instant('component.common.all'),
      value: '*',
    },
    {
      name: this.translate.instant('component.common.tech.android'),
      value: this.globals.tech_Android,
    },
    {
      name: this.translate.instant('component.common.tech.ios'),
      value: this.globals.tech_iOS,
    },
  ];
  filterDates: any = [
    {
      name: this.translate.instant('component.apps.filter.dates-filter.all'),
      value: '*',
    },
    {
      name: this.translate.instant(
        'component.apps.filter.dates-filter.last-week',
      ),
      value: this.week,
    },
    {
      name: this.translate.instant(
        'component.apps.filter.dates-filter.last-two-weeks',
      ),
      value: this.twoWeeks,
    },
    {
      name: this.translate.instant(
        'component.apps.filter.dates-filter.last-month',
      ),
      value: this.month,
    },
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private service: SecurityService,
    public dialog: MatDialog,
    private translate: TranslateService,
    public globals: Globals,
  ) {}

  toogleVarFilter(): void {
    this.resetScreenWidth();
    this.showAllFilters = !this.showAllFilters;
  }
  private resetScreenWidth() {
    this.pWidth = window.innerWidth;
  }
  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.tblData);
    this.loadedFindingsFiltered = this.tblData;
    this.findingsNumber = this.tblData.length;
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  ngAfterViewInit() {
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  goToFinding(selectedFinding) {
    return selectedFinding.finding.user_portal_url;
  }
  filterFindings(): void {
    this.loadedFindingsFiltered = [];
    if (this.tblData?.length > 0) {
      this.tblData.forEach((item) => {
        let lbAddItem = true;
        lbAddItem = this.checkPlatform(lbAddItem, item.app);
        lbAddItem = this.checkText(lbAddItem, item);
        lbAddItem = this.checkDate(lbAddItem, item);
        if (lbAddItem) {
          this.loadedFindingsFiltered.push(item);
        }
      });
      this.findingsNumber = this.loadedFindingsFiltered.length;
      this.dataSource = new MatTableDataSource(this.loadedFindingsFiltered);
    }
  }
  private checkPlatform(lbAddItem: boolean, item: any) {
    if (this.platform && lbAddItem) {
      lbAddItem =
        this.platform === '*' ||
        item.technology?.toLowerCase() === this.platform.toLowerCase();
    }
    return lbAddItem;
  }

  private checkDate(lbAddItem: boolean, item: any): boolean {
    if (lbAddItem && (!this.dateFilter || this.dateFilter === '*')) {
      return true;
    }
    const intValue = parseInt(this.dateFilter, 10);
    const comparisonDate = new Date();
    comparisonDate.setDate(comparisonDate.getDate() - intValue);
    return new Date(item.last) >= comparisonDate;
  }

  private checkText(lbAddItem: boolean, item: any) {
    if (this.txtSearch && lbAddItem) {
      lbAddItem =
        item.finding.title
          ?.toLowerCase()
          .indexOf(this.txtSearch?.toString().toLowerCase()) > -1 ||
        item.app.name
          ?.toLowerCase()
          .indexOf(this.txtSearch?.toString().toLowerCase()) > -1;
    }
    return lbAddItem;
  }

  openFindingDetailDialog(
    pItemSelected: SecurityFindingComment,
    psId: string,
  ): void {
    const params = {
      package: pItemSelected.app.package_name,
      technology: pItemSelected.app.technology,
      parameters: {
        app_security_id: psId,
      },
    };
    pItemSelected.finding.rldIcn = this.reloadIcon;
    this.getSecurityFindingsDetailDialog(psId, pItemSelected);
  }

  private getSecurityFindingsDetailDialog(
    psId: string,
    pItemSelected?: SecurityFindingComment,
  ) {
    const severity = 'severity';
    this.service
      .getSecurityFindingsDetail(pItemSelected.app.uuid, psId)
      .subscribe({
        next: (res: jsonResponseApi) => {
          const result = res;
          const data = {
            package: pItemSelected.app.package_name,
            technology: pItemSelected.app.technology,
            appUuid: pItemSelected.app.uuid,
            findingId: psId,
            result: result,
          };

          const ensureDialog = this.dialog.open(FindingDetailDialogComponent, {
            width: '760px',
            minHeight: '600px',
            panelClass: 'clsFindingDetailDialog',
            data: data,
          });
          if (pItemSelected) {
            pItemSelected.finding.rldIcn = this.closeTargetIcon;
          }
        },
      });
  }

  getClsSeverity(severity: String) {
    return {
      clsDot_cranberry: severity === 'CRITICAL',
      clsDot_critical: severity === 'HIGH',
      clsDot_medium: severity === 'MEDIUM',
      clsDot_minor: severity === 'LOW',
    };
  }
}
